module.exports = __webpack_public_path__ + "media/images/astro-thinking-3364a0f84aacfd49ee481c011c8fb354.svg";